import { BANNER_TYPES, DSBanner } from '@elliemae/ds-banner';
import { SchemaSearchForm } from '@frontend/pricing-search';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  getStateCounties,
  getZipLocations,
  calculateGovie,
} from '../../common/services/searchFormServices';
import { lookupsActions } from '../../store/lookups';
import {
  StyledEppsContainerBody,
  StyledEppsContainerHeader,
  StyledEppsFormWrapper,
  StyledEppsParentViewSearchForm,
  StyledEppsWrapper,
} from '../global/styles/styled';
import { ErrorBanner } from './components/ErrorBanner';
import { FooterForm } from './components/FooterForm';
import { HeaderForm } from './components/HeaderForm';
import { useIsZeroBasedPricing } from '../../common/utils/customHooks/useIsZeroBasedPricing';

export const SearchForm = ({
  schema,
  schemaForm,
  activeAccordions,
  setActiveAccordions,
  accordionFieldMap,
  onInitialized,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [showFeeReviewBanner, setShowFeeReviewBanner] = useState(
    !!(location.state as any)?.promptFeeReview,
  );
  const isZeroBasedPricing = useIsZeroBasedPricing();
  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(lookupsActions.getGeocodesDataAction({ dispatch } as any));
    dispatch(lookupsActions.getLookupsDataAction({ dispatch } as any));
  }, []);

  return (
    <StyledEppsParentViewSearchForm>
      <StyledEppsContainerBody>
        <StyledEppsWrapper>
          <StyledEppsContainerHeader>
            <ErrorBanner />
            <DSBanner
              isOpen={showFeeReviewBanner}
              onClose={() => setShowFeeReviewBanner(false)}
              label="Fee Factor Changed"
              body="Your government loan type has changed. Please review and update the fee amount fields."
              type={BANNER_TYPES.WARNING}
            />
          </StyledEppsContainerHeader>
          <HeaderForm />
          <StyledEppsFormWrapper>
            <SchemaSearchForm
              schema={schema}
              schemaForm={schemaForm}
              preview={false}
              getStateCounties={getStateCounties}
              getZipLocations={getZipLocations}
              calculateGovie={calculateGovie}
              activeAccordions={activeAccordions}
              setActiveAccordions={setActiveAccordions}
              isZeroBasedPricing={isZeroBasedPricing}
              onInitialized={onInitialized}
            />
          </StyledEppsFormWrapper>
        </StyledEppsWrapper>
      </StyledEppsContainerBody>
      <FooterForm
        schema={schema}
        schemaForm={schemaForm}
        accordionFieldMap={accordionFieldMap}
        setActiveAccordions={setActiveAccordions}
      />
    </StyledEppsParentViewSearchForm>
  );
};
